import {
  faUserCog,
  faLayerGroup,
  faShapes,
  faDisplay,
  faToiletPaper,
  faUserTag,
  faWifi,
  faWandMagicSparkles,
  faFolderOpen,
  faServer,
  faCog,
} from "@fortawesome/free-solid-svg-icons";
import { faTrello } from "@fortawesome/free-brands-svg-icons";

const DashboardItems = (state) => {
  let navItems = [{
    title: "Menu",
    pages: [{
      href: "/",
      icon: faLayerGroup,
      title: "Eventos"
    }],
  }]
  if (state.tipo === 1 || state.aplicativos_customizacao === 1) {
    navItems[0].pages.push({
      href: "/aplicativos",
      icon: faDisplay,
      title: "Aplicativos"
    })
  }
  if (state.tipo === 1) {
    navItems[1] = {
      title: "Gerenciamento",
      pages: [{
        href: "/usuarios",
        icon: faUserCog,
        title: "Usuários"
      },
      {
        href: "/trello",
        icon: faTrello,
        title: "Trello"
      },
      {
        href: "/armazenamento",
        icon: faFolderOpen,
        title: "Armazenamento",
      },
      {
        href: "/servidores",
        icon: faServer,
        title: "Servidores"
      },
      {
        href: "/logs",
        icon: faToiletPaper,
        title: "Log de erros",
        badge: state.logsErrorTotal > 0 ? state.logsErrorTotal : null,
      },
      {
        href: "/configuracoes-do-sistema",
        icon: faCog,
        title: "Configurações do sistema",
      }
      ]
    }
    // navItems[2] = {
    //   title: "Serviços",
    //   pages: [{
    //     href: "/orcamento-flex-2025",
    //     icon: faFileInvoiceDollar,
    //     title: "Gerar orçamentos"
    //   }]
    // }
    navItems[2] = {
      title: "Outros projetos",
      collapsible: true,
      defaultOpen: false,
      pages: [{
        href: "/outros-projetos/ai-vision",
        icon: faWandMagicSparkles,
        title: "AI Vision"
      },
      {
        href: "/outros-projetos/rfid-controller",
        icon: faWifi,
        title: "Controle RFID"
      },
      {
        href: "/outros-projetos/experiencias",
        icon: faShapes,
        title: "Experiências"
      }
      ]
    }
  }
  return navItems
}

export default DashboardItems;
